// extracted by mini-css-extract-plugin
export default {"image":"ImageOnly_image__2SkoQ","mobile":"ImageOnly_mobile__1jAhJ","description":"ImageOnly_description__gt9AV","desktop":"ImageOnly_desktop__F3juR"};